<template lang="pug">
  #signIn.h-100
    appHeader(:title="'會員卡'")
    router-view.content-body
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'MemberSignInComponent',
  components: {
    appHeader
  }
};
</script>
